import {
  ProductType,
  POST,
  TOPIC_PULSE,
  TOPLINE
} from "@futuri/cloudsso-client/src/client/types/productType";

export const useBranding = (product?: ProductType) => {
  const updateCSSVars = (darkColor: string, lightColor: string) => {
    const root = document.documentElement;
    root.style.setProperty("--brand-dark", darkColor);
    root.style.setProperty("--brand-light", lightColor);
  };

  switch (product) {
    case POST:
      updateCSSVars("#00856A", "#16C9A5");
      break;
    case TOPIC_PULSE:
      updateCSSVars("#cb2610", "#ee4833");
      break;
    case TOPLINE:
      updateCSSVars("#30780c", "#73b657");
      break;
    default:
      console.log(`Product ${product} not supported, using generic branding`);
      updateCSSVars("#30780c", "#73b657");
  }
};
